import IconTooltip from "components/Common/IconTooltip";
import { useRecoilState } from "recoil";
import { couponCodeAtom } from "src/atoms";
import { checkCoupon } from "src/service/pay";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
const CouponCode = () => {
  const [couponCodeInfo, setCouponCodeInfo] = useRecoilState(couponCodeAtom);
  const {
    setValue,
    setError,
    watch,
    formState: { errors },
  } = useFormContext();
  const couponCode = watch("couponCode");
  const { t } = useTranslation();
  return (
    <span
      className="form-item-title flex align-center"
      style={{ marginBottom: "4px" }}
    >
      <span className="form-item-title">
        <span className="mg mr-6">할인 쿠폰(선택)</span>
        <IconTooltip
          iconType="info"
          innerWidth="460px"
          isShowCard={false}
          textAlign="start"
          padding="10px"
        >
          <ul className="d-flex gap-1 flex-wrap">
            <li>할인쿠폰은 최초 결제 시에만 적용됩니다.</li>
            <li>할인쿠폰은 어떤 상황에도 환불 및 현금화하실 수 없습니다.</li>
            <li>
              할인쿠폰의 유효기간과 제한 조건 등은 쿠폰마다 다르게 설정되어
              있습니다.
            </li>
            <li>
              반드시 합계 금액에 할인이 적용된 것을 확인한 다음 결제를 진행해
              주세요.
            </li>
          </ul>
        </IconTooltip>
      </span>

      <Form.Group className="d-flex gap-2 ">
        <div>
          <Form.Control
            name="couponCode"
            value={couponCode}
            onChange={(e) => {
              const rawValue = e.target.value;

              // 한글 감지
              const hasKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(rawValue);

              if (hasKorean) {
                setError("couponCode", {
                  message: "영문과 숫자만 입력할 수 있습니다.",
                });
              }

              // 대문자 변환 (특수문자 제거는 yup이 담당)
              const upperCaseValue = rawValue.toUpperCase();
              setValue("couponCode", upperCaseValue, { shouldValidate: true });
            }}
            className="form-control custom-form width w-370"
            placeholder={"할인 코드를 입력해주세요."}
            isInvalid={!!errors.couponCode}
          />
          <Form.Control.Feedback type="invalid">
            <>{errors?.couponCode?.message}</>
          </Form.Control.Feedback>
        </div>
        <div>
          <button
            className="btn btn-green"
            // style={{ position: "absolute" }}
            onClick={(e) => {
              e.preventDefault();
              checkCoupon({
                couponCode,
                product: getProductFromSessionStorage(),
              })
                .then((res) => {
                  alert("쿠폰이 적용되었습니다.");
                  // console.log("적용된 쿠폰", res);
                  setCouponCodeInfo(res);
                })
                .catch((e) => {
                  console.log("쿠폰 체크 에러", e);
                });
            }}
          >
            {t("siteType.premium.detail.plan.registerBtn")}
          </button>
        </div>
      </Form.Group>
    </span>
  );
};

export default CouponCode;
